<script>
export default {
  data() {
    return {
      searchQuery: '',
    };
  },
  methods: {
    onInput() {
      this.$emit('search', this.searchQuery)
    },
  },
}
</script>
<template>
  <div class="faq-search">
    <input
      v-model="searchQuery"
      type="text"
      :placeholder="$t('global.the.search')"
      @input="onInput"
    />
  </div>
</template>
<style scoped>
.faq-search {
  margin-bottom: 2rem;
}
input {
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
}
</style>